import { Button } from "@mui/material";
import React, { useState, useRef } from "react";
import { API_URL } from '../../Constants';

export default function ImageUpload(props) {

  const inputFile = useRef(null);

  let apiUrl = API_URL;

  const handleFileUpload = e => {
    const { files } = e.target;
    if (files && files.length) {
      const filename = files[0].name;
      console.log("filename: " + filename);

      console.log("entro a la carga de sistema");
      var parts = filename.split(".");
      const fileType = parts[parts.length - 1];
      console.log("fileType", fileType); //ex: zip, rar, jpg, svg etc.

      const imageRequest = new FormData();
      imageRequest.set('image', files[0]);
      imageRequest.set('name', props.name);

      fetch(apiUrl + '/v1/credits/client/' + props.clientUuid + '/commerce/' + localStorage.getItem("commerceUuid") + '/upload-document', {
        method: 'POST',
        body: imageRequest,
      }).then(function (response) {
        if (response.ok) {
          props.efecinco(1);
        }
      }).catch(function (error) {
        console.log('Hubo un problema con la petición Fetch:' + error.message);
      });
    }
  };

  const onButtonClick = () => {
    inputFile.current.click();
  };

  return (
    <div>
      <input
        style={{ display: "none" }}
        // accept=".zip,.rar"
        ref={inputFile}
        onChange={handleFileUpload}
        type="file"
      />
      <Button onClick={onButtonClick}>
        Cargar imagen
      </Button>
    </div>
  );
};

